var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _circle2, _path18, _rect4, _rect5, _line, _line2, _line3, _path19, _line4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 217,
    viewBox: "0 0 230 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.4535,
    y: 71.7825,
    width: 71,
    height: 10,
    rx: 5,
    fill: "white",
    stroke: "#ADABFF",
    strokeWidth: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.4535,
    y: 143.783,
    width: 71,
    height: 10,
    rx: 5,
    fill: "white",
    stroke: "#ADABFF",
    strokeWidth: 5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.45346,
    y: 51.7825,
    width: 107,
    height: 10,
    rx: 5,
    fill: "white",
    stroke: "#ADABFF",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.677 16.8769C164.968 16.559 167.381 13.6703 167.067 10.4248C166.754 7.17939 163.832 4.8062 160.541 5.12417C157.251 5.44214 154.837 8.33085 155.151 11.5763C155.465 14.8217 158.386 17.1949 161.677 16.8769Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.215 42.1597C130.951 41.7987 133.691 38.5191 133.335 34.8344C132.979 31.1498 129.662 28.4555 125.926 28.8165C122.19 29.1775 119.45 32.4571 119.806 36.1417C120.162 39.8264 123.48 42.5207 127.215 42.1597Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.024 157.012C25.76 156.651 28.4999 153.371 28.1438 149.686C27.7878 146.002 24.4706 143.307 20.7347 143.668C16.9988 144.029 14.2589 147.309 14.6149 150.994C14.971 154.678 18.2881 157.373 22.024 157.012Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1359 34.6785L72.9842 42.6776",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9928 43.5465L72.1273 33.8096",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.64 47.9391L205.959 50.976",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.196 55.5954L201.403 43.3198",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0288 113.464L41.9416 146.882C42.0087 147.576 42.7798 148.203 43.4392 147.672L72.8418 130.813C73.5235 130.513 73.434 129.587 72.9199 129.17L43.6045 112.611C42.8557 112.216 41.9617 112.77 42.0288 113.464Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.309 102.922L203.66 110.625C203.376 110.785 203.345 111.173 203.598 111.4L217.017 119.233C217.365 119.407 217.744 119.193 217.681 118.859L217.91 103.322C217.994 103.028 217.593 102.761 217.309 102.922Z",
    stroke: "#ADABFF",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.166 152.675C165.768 152.675 185.711 132.491 185.711 107.593C185.711 82.695 165.768 62.5111 141.166 62.5111C116.564 62.5111 96.6206 82.695 96.6206 107.593C96.6206 132.491 116.564 152.675 141.166 152.675Z",
    fill: "#ADABFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.015 140.868C141.32 140.868 161.024 120.924 161.024 96.3226C161.024 71.7209 141.32 51.7773 117.015 51.7773C92.7096 51.7773 73.0062 71.7209 73.0062 96.3226C73.0062 120.924 92.7096 140.868 117.015 140.868Z",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M185.175 76.465C189.621 76.465 193.225 72.8607 193.225 68.4146C193.225 63.9686 189.621 60.3643 185.175 60.3643C180.729 60.3643 177.124 63.9686 177.124 68.4146C177.124 72.8607 180.729 76.465 185.175 76.465Z",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4696 168.776C76.9157 168.776 80.52 165.172 80.52 160.725C80.52 156.279 76.9157 152.675 72.4696 152.675C68.0235 152.675 64.4193 156.279 64.4193 160.725C64.4193 165.172 68.0235 168.776 72.4696 168.776Z",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7818 70.0247C52.2279 70.0247 55.8322 66.4204 55.8322 61.9744C55.8322 57.5283 52.2279 53.924 47.7818 53.924C43.3357 53.924 39.7315 57.5283 39.7315 61.9744C39.7315 66.4204 43.3357 70.0247 47.7818 70.0247Z",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.176 80.7585C192.842 80.7585 199.216 86.2569 200.689 93.5476C201.019 95.2184 199.665 96.8892 198.012 96.8588H190.225H172.278C170.625 96.8588 169.332 95.3399 169.663 93.6692C169.903 92.4237 170.294 91.2085 170.835 90.0846L170.805 90.0542C171.497 88.5049 172.428 87.0771 173.571 85.862C176.457 82.7331 180.606 80.7585 185.176 80.7585Z",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4705 173.069C80.1369 173.069 86.5104 178.568 87.9836 185.858C88.3143 187.529 86.9601 189.2 85.3066 189.17H77.52H59.5731C57.9196 189.17 56.6268 187.651 56.9575 185.98C57.198 184.734 57.5889 183.519 58.13 182.395L58.1 182.365C58.7914 180.816 59.7234 179.388 60.8658 178.173C63.752 175.044 67.9008 173.069 72.4705 173.069Z",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7828 74.3182C55.4491 74.3182 61.8227 79.8166 63.2958 87.1074C63.6265 88.7781 62.2724 90.4489 60.6189 90.4186H52.8323H34.8853C33.2318 90.4186 31.9391 88.8997 32.2698 87.2289C32.5103 85.9834 32.9011 84.7683 33.4423 83.6443L33.4122 83.6139C34.1037 82.0646 35.0357 80.6369 36.1781 79.4217C39.0642 76.2928 43.2131 74.3182 47.7828 74.3182Z",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93.4005,
    cy: 102.226,
    r: 5.36691,
    fill: "#5A4BF8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.556,
    cy: 102.226,
    r: 5.36691,
    fill: "#5A4BF8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M125.459 116.379C120.245 121.592 111.793 121.592 106.579 116.379",
    stroke: "#5A4BF8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 145.996,
    y: 130.134,
    width: 55.8158,
    height: 55.8158,
    rx: 8,
    fill: "#ADABFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 138.836,
    y: 121.9,
    width: 50.8158,
    height: 50.8158,
    rx: 5.5,
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 150.643,
    y1: 137.295,
    x2: 161.744,
    y2: 137.295,
    stroke: "#5A4BF8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150.643,
    y1: 145.882,
    x2: 156.377,
    y2: 145.882,
    stroke: "#5A4BF8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 150.643,
    y1: 154.469,
    x2: 156.377,
    y2: 154.469,
    stroke: "#5A4BF8",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M170.838 147.098L205.359 127.167C206.316 126.615 207.539 126.942 208.092 127.899L212.532 135.59C213.084 136.546 212.756 137.769 211.8 138.322L177.278 158.253L168.698 156.647C168.095 156.534 167.735 155.91 167.939 155.332L170.838 147.098Z",
    fill: "white",
    stroke: "#5A4BF8",
    strokeWidth: 5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 197.172,
    y1: 131.894,
    x2: 203.076,
    y2: 142.119,
    stroke: "#5A4BF8",
    strokeWidth: 5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.b549c7c14f1e269776a50e4902abdceb.svg";
export { ForwardRef as ReactComponent };